<template>
  <div class="skill-page">
    <div class="page-header">
      <h2>下拉选择器组件技能库</h2>
      <p>展示Element UI下拉选择器组件的个性化用法</p>
    </div>

    <el-row :gutter="20">
      <el-col :xs="24" :sm="12" :md="8" :lg="6">
        <CodeCard 
          title="多选下拉框" 
          description="支持全选功能的多选下拉框，带有折叠标签显示"
          :codeContent="selectCode">
          <MultiSelect />
        </CodeCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CodeCard from '@/components/CodeCard.vue'
import MultiSelect from './components/MultiSelect.vue'

export default {
  name: 'PcSelect',
  components: {
    CodeCard,
    MultiSelect
  },
  data() {
    return {
      selectCode: `<template>
  <el-select
    v-model="localValue"
    multiple
    collapse-tags
    clearable
    placeholder="请选择"
  >
    <el-option value="ALL">
      <el-checkbox
        v-model="checkAll"
        @change="handleCheckAllChange"
        :indeterminate="isIndeterminate"
      >全选</el-checkbox>
    </el-option>
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script>
export default {
  data() {
    return {
      localValue: [],
      options: [
        { value: '1', label: '选项1' },
        { value: '2', label: '选项2' },
        { value: '3', label: '选项3' },
      ],
      checkAll: false,
      isIndeterminate: false,
    }
  },
  methods: {
    handleCheckAllChange(val) {
      const allValues = this.options.map(item => item.value);
      this.localValue = val ? allValues : [];
      this.isIndeterminate = false;
    }
  }
}
<\/script>`
    }
  }
}
</script>

<style scoped>
/* 全局样式已由 global.scss 提供 */
</style>
